import { X, Check } from 'lucide-react'
import { cn } from '@/lib/utils'
import { useIntersectionObserver } from '@/hooks/use-intersection-observer'

export function TimeEnemy() {
  const { elementRef, isVisible } = useIntersectionObserver()

  return (
    <section ref={elementRef} className="py-24 bg-slate-50 overflow-hidden">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-extrabold text-brand-navy mb-4">
            O tempo é o maior inimigo
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            Você não precisa de mais candidatos. Precisa da pessoa certa,
            rápido.
          </p>
        </div>

        <div className="flex flex-col md:flex-row gap-8 lg:gap-16 items-center justify-center max-w-5xl mx-auto">
          {/* Them */}
          <div
            className={cn(
              'flex-1 w-full bg-white p-8 rounded-2xl border border-slate-200 shadow-sm relative overflow-hidden',
              isVisible ? 'animate-slide-up' : 'opacity-0',
            )}
          >
            <div className="absolute top-0 left-0 w-full h-1 bg-red-400"></div>
            <h3 className="text-xl font-bold text-slate-500 mb-6 flex items-center gap-2">
              <X className="w-6 h-6 text-red-400" />
              Outras Plataformas
            </h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3 text-slate-600">
                <X className="w-5 h-5 text-red-400 shrink-0 mt-0.5" />
                <span>Currículos genéricos e desatualizados</span>
              </li>
              <li className="flex items-start gap-3 text-slate-600">
                <X className="w-5 h-5 text-red-400 shrink-0 mt-0.5" />
                <span>Processos longos e burocráticos</span>
              </li>
              <li className="flex items-start gap-3 text-slate-600">
                <X className="w-5 h-5 text-red-400 shrink-0 mt-0.5" />
                <span>Filtros que não entendem de escola</span>
              </li>
              <li className="flex items-start gap-3 text-slate-600">
                <X className="w-5 h-5 text-red-400 shrink-0 mt-0.5" />
                <span>Caixa de entrada lotada de spam</span>
              </li>
            </ul>
          </div>

          {/* VS Badge */}
          <div className="w-12 h-12 rounded-full bg-slate-200 flex items-center justify-center font-bold text-slate-500 shrink-0 border-4 border-slate-50 z-10 -my-6 md:my-0 md:-mx-8">
            VS
          </div>

          {/* Us */}
          <div
            className={cn(
              'flex-1 w-full bg-white p-8 rounded-2xl border-2 border-brand-emerald shadow-xl relative overflow-hidden transform md:scale-105 z-0',
              isVisible ? 'animate-slide-up' : 'opacity-0',
            )}
            style={{ animationDelay: '200ms' }}
          >
            <div className="absolute top-0 left-0 w-full h-1.5 bg-brand-emerald"></div>
            <h3 className="text-2xl font-bold text-brand-navy mb-6 flex items-center gap-2">
              <div className="w-8 h-8 rounded bg-brand-emerald flex items-center justify-center text-white text-sm font-bold">
                FE
              </div>
              Farol Edu
            </h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3 text-brand-navy font-medium">
                <Check className="w-5 h-5 text-brand-emerald shrink-0 mt-0.5" />
                <span>Foco 100% no contexto escolar</span>
              </li>
              <li className="flex items-start gap-3 text-brand-navy font-medium">
                <Check className="w-5 h-5 text-brand-emerald shrink-0 mt-0.5" />
                <span>Agilidade garantida na triagem</span>
              </li>
              <li className="flex items-start gap-3 text-brand-navy font-medium">
                <Check className="w-5 h-5 text-brand-emerald shrink-0 mt-0.5" />
                <span>Filtros específicos (disciplina, etapa)</span>
              </li>
              <li className="flex items-start gap-3 text-brand-navy font-medium">
                <Check className="w-5 h-5 text-brand-emerald shrink-0 mt-0.5" />
                <span>Candidatos ativos e verificados</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  )
}
